<template>
  <NotificationTemplate :notification="notification">
    <template #pic>
      <Avatar
        :src="notification.initiatorAvatarSrc || null"
        :gap="notification.getInitials()"
      />
    </template>
    <template #title>
      <BaseSubHeading
        size="large"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="400"
      >
        <span class="notification__update-item__initiator">{{
          notification.initiatorFullName
        }}</span>
        {{ notificationTitle }}
        <a
          class="link is-large"
          target="_blank"
          :href="notification.itemUrl"
        >
          Item {{ notification.itemSequenceNumber }}:
        </a>
      </BaseSubHeading>
    </template>
    <template #content>
      <BaseSubHeading
        size="medium"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="400"
        className="notification__update-item__description"
      >
        <template v-if="timestamp">
          <CommentTimestampText
            :timestamp="timestamp"
            :clickable="true"
            className="comment-content__timestamp_notification notification__timestamp"
            @timestampClick="emitDemoVideoTimestamp"
          />
          <ReferencedText
            :resetStyle="true"
            :html="notification.comment"
          />
        </template>
        <ReferencedText
          v-else
          :resetStyle="true"
          :html="notification.comment"
        />
      </BaseSubHeading>

      <NotificationAttachmentFiles
        v-if="notification.attachments.length"
        :attachments="notification.attachments"
        :itemUrl="notification.resourceUrl"
        :attachmentsCount="notification.attachmentsCount"
      />
    </template>
  </NotificationTemplate>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Emit, Prop } from "vue-property-decorator"

import Avatar from "@/components/Avatar/index.vue"
import CommentTimestampText from "@/components/Comment/CommentTimestampText.vue"
import NotificationAttachmentFiles from "@/components/Notification/components/NottificationAttacmentFiles.vue"
import NotificationTemplate from "@/components/Notification/NotificationTemplate.vue"

import { NotificationComment } from "@/models/Notification/NotificationComment"
import { formatTimestamp } from "@/utils/timestampUtil"

import { ReferencedText } from "../../Reference"

@Options({
  name: "COMMENTS",
  components: {
    NotificationAttachmentFiles,
    NotificationTemplate,
    Avatar,
    CommentTimestampText,
    ReferencedText
  }
})
export default class COMMENTS extends Vue {
  @Prop() readonly notification: NotificationComment

  get notificationTitle() {
    return this.notification.demoVideoId
      ? "added a comment to Demo Video for"
      : "added a comment to"
  }

  get timestamp() {
    return this.notification.demoVideoTimestamp !== null && this.notification.demoVideoTimestamp > 0
      ? formatTimestamp(this.notification.demoVideoTimestamp)
      : ""
  }

  @Emit("demoVideoTimestampSelect")
  emitDemoVideoTimestamp(seconds: number) {
    return {
      initialTimestampSeconds: seconds,
      scrollToCommentId: this.notification.commentId,
      itemUrl: this.notification.resourceUrl || this.notification.itemUrl,
      demoVideoId: this.notification.demoVideoId
    }
  }
}
</script>
